import { isNativeAndroid, sendToNative } from './NativeUtil';

// 위치 정보를 가져오는 헬퍼 함수
const getCurrentPosition = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const newLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          resolve(newLocation);
        },
        (error) => {
          reject(error);
        },
        {
          enableHighAccuracy: true, // 높은 정확도 사용
          maximumAge: 0, // 캐시된 위치 정보 사용 안 함
          timeout: 10000 // 10초 타임아웃
        }
      );
    } else {
      reject(new Error('Geolocation is not supported'));
    }
  });
};

// 딜레이 함수
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export default async function requestGeoLocation() {
  let state = '';
  let permissionRequested = false;

  // 위치 권한 코드
  try {
    // navigator.permissions API가 지원되는 경우
    if (navigator.permissions?.query) {
      const permissionStatus = await navigator.permissions.query({
        name: 'geolocation'
      });
      state = permissionStatus.state; // 'granted', 'denied', 'prompt' 중 하나
    } else {
      // navigator.permissions API를 지원하지 않는 경우
      state = 'not-supported';
    }
    window.Android?.androidLogcat("State: " + state);

    // 권한이 granted가 아닌 경우 네이티브에 권한 요청
    if (state !== 'granted') {
      if (isNativeAndroid() && window.Android) {
        window.Android?.androidLogcat("Requesting geolocation permission from native");
        window.Android?.authGeoLocation('authGeoLocation');
        permissionRequested = true;
      } else if (window.webkit?.messageHandlers?.pocapanEvent) {
        // iOS인 경우
        sendToNative(`{"type": "authGeoLocation", "value": "authGeoLocation"}`);
        permissionRequested = true;
      }
    }
  } catch (error) {
    if (error instanceof Error) {
      state = `권한 확인 중 오류가 발생했습니다: ${error.message}`;
      window.Android?.androidLogcat(state);

      if (window.webkit?.messageHandlers?.pocapanEvent && error.name === 'NotAllowedError') {
        // ios인지 확인
        sendToNative(`{"type": "authGeoLocation", "value": "authGeoLocation"}`);
        permissionRequested = true;
      } else if (isNativeAndroid() && window.Android) {
        window.Android?.androidLogcat("Error: " + error.message);
        window.Android?.authGeoLocation('authGeoLocation');
        permissionRequested = true;
      } else {
        // 다른 오류에 대해서는 그대로 에러를 다시 발생시킴
        throw error;
      }
    }
  }

      // 네이티브에 권한 요청을 보낸 경우 잠시 대기
  if (permissionRequested) {
    window.Android?.androidLogcat("Waiting for permission response...");
    await delay(2000); // 네이티브 권한 처리 완료 대기
  }

  // 위치 정보 가져오기 (재시도 로직 포함)
  let retryCount = 0;
  const maxRetries = 3; // 적절한 재시도 횟수

  while (retryCount < maxRetries) {
    try {
      window.Android?.androidLogcat(`Attempting to get location (attempt ${retryCount + 1})`);
      const location = await getCurrentPosition();
      window.Android?.androidLogcat(`Location obtained: ${location.lat}, ${location.lng}`);
      return location;
    } catch (error) {
      retryCount++;
      window.Android?.androidLogcat(`Location attempt ${retryCount} failed: ${error.message}`);

      // 권한 관련 에러인 경우 즉시 종료
      if (error.message.includes('denied') || error.message.includes('denied')) {
        window.Android?.androidLogcat("Permission denied, stopping retry attempts");
        throw error;
      }

      if (retryCount < maxRetries) {
        // 재시도 전 잠시 대기 (점진적으로 증가)
        const delayTime = 1000 + (retryCount * 500); // 1초, 1.5초, 2초...
        window.Android?.androidLogcat(`Waiting ${delayTime}ms before retry`);
        await delay(delayTime);
              } else {
          // 최대 재시도 횟수 도달
          window.Android?.androidLogcat("All location attempts failed");
          throw error;
        }
    }
  }
}
